<modal
    [id]="id() + '-api-messages-response'"
    [title]="'api.responseMessage.info'"
    [dismissableMask]="true"
    [visible]="isVisible()"
    (visibleChange)="onHide.emit()">
    <div body>
        @if ((data()?.errorMessages || []).length > 0) {
            <div class="error-container">
                <p class="title">
                    <i class="fa-sharp fa-solid fa-circle-exclamation"></i>
                    {{ 'api.responseMessage.error' | translate }}
                </p>

                <ul>
                    @for (message of data()?.errorMessages; let rowIndex = $index; track rowIndex) {
                        <li>{{ message }}</li>
                    }
                </ul>
            </div>
        }

        @if ((data()?.warningMessages || []).length > 0) {
            <div class="warning-container">
                <p class="title">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    {{ 'api.responseMessage.warning' | translate }}
                </p>

                <ul>
                    @for (message of data()?.warningMessages; let rowIndex = $index; track rowIndex) {
                        <li>{{ message }}</li>
                    }
                </ul>
            </div>
        }

        @if ((data()?.successMessages || []).length > 0) {
            <div class="success-container">
                <p class="title">
                    <i class="fa-solid fa-circle-check"></i>
                    {{ 'api.responseMessage.success' | translate }}
                </p>

                <ul>
                    @for (message of data()?.successMessages; let rowIndex = $index; track rowIndex) {
                        <li>{{ message }}</li>
                    }
                </ul>
            </div>
        }
    </div>
</modal>
